import React, { useEffect } from 'react';
import './NavigationButton.scss';
import { Icons } from '../../utilities';

const navigationButton = props => {
  const { direction, clickHandler, wallSidesWidth } = props;

  const directionalIcon =
    direction == 'left'
      ? Icons.navigationArrowLeft
      : Icons.navigationArrowRight;
  const styleClassName =
    direction == 'left' ? 'leftNavigation' : 'rightNavigation';

  useEffect(() => {
    const element = document.getElementById(direction);
    let leftDistance = 0;
    let rightDistance = 0;
    let imgSize = 60;
    if (wallSidesWidth >= 40 && wallSidesWidth < 70) {
      leftDistance = wallSidesWidth - 55;
      rightDistance = wallSidesWidth - 55;
      imgSize = 40;
    } else if (wallSidesWidth >= 70 && wallSidesWidth < 100) {
      leftDistance = 0;
      rightDistance = 0;
    } else {
      leftDistance = wallSidesWidth - 100;
      rightDistance = wallSidesWidth - 100;
    }

    element.style.setProperty('--wall-side-width', `${wallSidesWidth}px`);
    element.style.setProperty('--left-distance', `${leftDistance}px`);
    element.style.setProperty('--img-size', `${imgSize}px`);
    element.style.setProperty('--right-distance', `${rightDistance}px`);
  }, [wallSidesWidth]);

  return (
    <button
      type='button'
      className={styleClassName}
      style={{
        border: 'none',
        background: 'none',
        outline: 'none',
        pointerEvents: 'auto'
      }}
      onClick={clickHandler}
      id={direction}
    >
      <img className='nav-image' src={directionalIcon} alt='navigationArrow' />
    </button>
  );
};

export default navigationButton;
